import { endPointBulkCartUpdate, getEPProductUpdates } from "../../main/services/endpoints"
import { FetchDataOptions } from "modules/main/services/fetchData";
import { ProductUpdates } from "../types/updates";
import { AddCartMethod } from "modules/cart/types/add-cart-methods";
import { AuthError } from "modules/authentication/types/form-login-types";
import apiClient from "modules/main/services/apiClient";



export const getUpdates = async (
    sku:string,
    method:AddCartMethod,
    abortController?: AbortController
):Promise<ProductUpdates> =>  {
    const controller = abortController || new AbortController();
    const signal = controller.signal;
    const defaultOptions:FetchDataOptions = {
        method:"GET",
        headers:{},
        body:undefined,
        credentials:"include",
    }
    try{
        const response = await fetch(getEPProductUpdates(sku),{
                            // method:defaultOptions.method,
                            headers:defaultOptions.headers,
                            body:JSON.stringify(defaultOptions.body),
                            credentials:defaultOptions.credentials,
                            signal}); 
        if(!response.ok){
            if (response.status === 401){
                throw new AuthError("Unauthorized");
            }
            throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        return data
    }
    catch(error){
        throw error;
    }
    

}

/**
 * Single-item shape sent to the backend bulk product-update trigger.
 * `store_id` is optional — the backend accepts and forwards it when provided.
 */
export type BulkUpdateItem = {
    product_id: string;
    store_id?: string;
};

/**
 * Merges items from two sources — resolved items from `applyListExecution` and
 * catalog ids from linked temporary items — into the backend bulk-contract
 * shape. Strips out `sku` because the backend only requires `product_id`.
 * @param inserted - Items already inserted into the cart (with both product_id and sku).
 * @param linkedTemporaryProductIds - Catalog product ids of linked temporary items.
 * @returns Flat array of `BulkUpdateItem` ready for the request body.
 */
export const buildBulkUpdateItems = (
    inserted: { product_id: string; sku: string }[],
    linkedTemporaryProductIds: string[],
): BulkUpdateItem[] => {
    const fromResolved = inserted.map(({ product_id }) => ({ product_id }));
    const fromLinkedTemp = linkedTemporaryProductIds.map((product_id) => ({ product_id }));
    return [...fromResolved, ...fromLinkedTemp];
};

/**
 * Sends one non-blocking batch product update trigger to the backend.
 * @param items - Resolved catalog items to dispatch for an update pass.
 */
export const triggerBatchProductUpdates = async (items: BulkUpdateItem[]): Promise<void> => {
    if (items.length === 0) return;
    await apiClient.post(endPointBulkCartUpdate(), { items });
};
